export default {"src":"/_next/static/media/constLogo3.27e01ac9.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};